import { EnvironmentSwitch } from 'components/ui'
import { cn } from 'utils/cn'
import { useOperationEnvironment } from 'contexts/OperationEnvironmentContext'

interface Props {
  collapsed?: boolean
}

const OperationEnvironmentToggle: React.FC<Props> = ({ collapsed }) => {
  const { environment, setEnvironment, isLive } = useOperationEnvironment()

  return (
    <div className={cn('flex', collapsed ? 'justify-center' : 'justify-start')}>
      <EnvironmentSwitch
        environment={environment}
        onToggle={() => setEnvironment(isLive ? 'sandbox' : 'live')}
        showLabel={!collapsed}
      />
    </div>
  )
}

export default OperationEnvironmentToggle
